import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'empty-list-component',
    templateUrl: 'empty-list-component.html',
    styleUrls: ['./empty-list-component.scss']
})

export class EmptyListComponent implements OnInit {

    @Input() profissionalInfo: any = {};
    @Input() infoUser: any = {};
    @Input() image: any = {};
    @Input() tipo: string;
    @Input() mensagem: any;
    @Input() searchQuery: any;

    titulo = `ProSaúde`;
    
    searchEmpty = 'Nenhum registro encontrado';

    constructor() {
    }

    ngOnInit() {
        if (!this.searchQuery) {
            switch (this.tipo) {
                // case 'VACINAS':
                //     this.mensagem = `Essa é a sua Carteira de Vacinação Digital e atualmente são exibidos dados da vacina contra a COVID-19. Os registros são carregados após a entrada dos dados nos sistemas de informação, o que pode ocorrer em até 10 dias. Em breve serão disponibilizadas as demais vacinas já recebidas pelo SUS. Em caso de ausência ou divergência de informação, entre em contato com a Unidade de Saúde mais próxima.`;
                // break;
          
                // case 'EXAMES':
                //     this.mensagem = `Atualmente o Conecte SUS apresenta os dados de exame de COVID-19 dos sistemas de informação integrados com o Ministério da Saúde. Em breve novos exames serão disponibilizados. Em caso de ausência ou divergência de informação, entre em contato com o Laboratório ou a Unidade de Saúde em que o exame foi realizado.`;
                // break;
          
                // case 'ATENDIMENTOS':
                //     this.mensagem = `Atualmente o Conecte SUS apresenta os dados de internações realizadas no SUS a partir de abril de 2018. Em breve novas internações e atendimentos serão disponibilizados. Em caso de ausência ou divergência de informação, entre em contato com a Unidade de Saúde mais próxima.`;
                // break;
          
                // case 'MEDICAMENTOS':
                //     this.mensagem = `Atualmente o Conecte SUS apresenta os dados dos medicamentos dispensados pelo SUS. Em caso de ausência ou divergência de informação, entre em contato com o estabelecimento no qual o medicamento foi retirado.`;
                // break;
          
                // case 'ALERGIAS':
                //     this.mensagem = `O Conecte SUS será atualizado e disponibilizará gradativamente suas alergias pelo SUS.`;
                // break;

                default:
                    this.mensagem = `Não há registros`;
                break;
            }
        } else {
            this.mensagem = this.searchEmpty;
        }
    }
}
